/* Auto generated file */
/* eslint-disable */
import { SVGIconSprite, type SVGIconSpriteProps } from '../icon/SVGIconSprite';

const Add = (props: SVGIconSpriteProps) =>
    <SVGIconSprite {...props} icon="add" />;

export { Add, Add as default };
